import React from 'react';
import axios from 'axios';
import get from 'lodash/get';
import { withFormik } from 'formik';

import { Button } from '@lightspeed/flame/Button';
import Group from '@lightspeed/cirrus-group';
import Modal, { ModalHeader, ModalBody, ModalFooter } from '@lightspeed/cirrus-modal';
import Text from '@lightspeed/cirrus-text';

const DeleteEcomModal = ({ handleSubmit, isSubmitting, onAfterOpen, onClose }) => (
  <Modal className="cirrus" isOpen onAfterOpen={onAfterOpen} onRequestClose={() => onClose()}>
    <ModalHeader onCloseClicked={() => onClose()}>Delete eCom Integration</ModalHeader>
    <ModalBody>
      <Text body color="gray" className="cr-mb-2">
        <strong>WARNING</strong>: This action is destructive and cannot be undone.
      </Text>
      <Text body color="gray">
        Deleting the eCom Integration will:
      </Text>
      <ul className="cr-mv-0">
        <li>
          <Text body color="gray">
            Break the connection from Retail to the eCom shop forever.
          </Text>
        </li>
        <li>
          <Text body color="gray">
            Clear out the publish to eCom checkbox for all products.
          </Text>
        </li>
      </ul>
    </ModalBody>
    <ModalFooter>
      <Group className="cr-justify-end">
        <Button onClick={() => onClose()}>No, don&#39;t do it</Button>
        <Button variant="danger" fill loading={isSubmitting} onClick={handleSubmit}>
          I understand. Delete eCom Integeation
        </Button>
      </Group>
    </ModalFooter>
  </Modal>
);

const enhancedDeleteEcomModal = withFormik({
  handleSubmit: async (values, formikBag) => {
    formikBag.setSubmitting(true);

    const { accountId } = formikBag.props;

    try {
      await axios.delete(`/staff/accounts/${accountId}/ecom`);
      formikBag.props.onConfirm({
        message: 'Ecom Integration deleted.',
        updateData: true,
        forceClearData: true,
      });
    } catch (e) {
      window.alertUser(get(e, 'response.data.errors[0].detail') || 'An error occurred');
    }

    formikBag.setSubmitting(false);
    formikBag.props.onClose(true);
  },
})(DeleteEcomModal);

export default enhancedDeleteEcomModal;
